import styles from './FormPageLoading.module.scss'

type FormPageLoadingProps = {
    title?: string
    message?: string
    /** 0–100; omit for indeterminate bar */
    progress?: number
}

/**
 * Full-width placeholder used between claim submit and sign-page load so the
 * layout does not collapse to header/footer only.
 */
export const FormPageLoading = ({
    title = 'Preparing your documents',
    message = 'This usually takes a few seconds…',
    progress,
}: FormPageLoadingProps) => (
    <div className={styles.root} role="status" aria-live="polite" aria-busy="true">
        <div className={styles.card}>
            <div className={styles.spinner} aria-hidden="true" />
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.message}>{message}</p>
            <div className={styles.progressTrack}>
                <div
                    className={
                        typeof progress === 'number' ? styles.progressBarDeterminate : styles.progressBarIndeterminate
                    }
                    style={typeof progress === 'number' ? { width: `${Math.max(0, Math.min(100, progress))}%` } : undefined}
                />
            </div>
        </div>
    </div>
)
